import newsApi from '@/store/newsApi'

const news = {
  state: {
    index: null,
    article: null
  },
  mutations: {
    setIndex (currentNewsState, index) {
      currentNewsState.index = index
    },
    setArticle (currentNewsState, article) {
      currentNewsState.article = article
    }
  },
  actions: {
    getIndex: async function (context) {
      console.log('Store - News - GetIndex')
      let result = await newsApi.getIndex()
      console.log('Index Retrieved')
      console.log(result)
      context.commit('setIndex', result)
    },
    getArticle: async function (context, newsId) {
      console.log(`Store - News - GetArticle #${newsId}`)
      let result = await newsApi.getArticle(newsId)
      console.log('Article Retrieved')
      console.log(result)
      context.commit('setArticle', result)
    }
  },
  getters: {
    loadIndex: state => {
      return state.index
    },
    loadTopFive: state => {
      let topFive = []
      for (var ii in state.index) {
        if (topFive.length >= 3) break
        topFive.push(state.index[ii])
      }

      topFive.reverse()
      return topFive
    },
    loadArticle: state => {
      return state.article
    }
  }
}

export default news
